module.exports = __webpack_public_path__ + "img/icon_vidal.ed2f6417.png";